export class ClaimPermissionsSuccess {
    static readonly type = '[User] ClaimPermissionsSuccess';
}
